import { NavItemDefault } from './NavItemDefault';
import { NavItemProps } from './types';

export function NavItem<TPopoverProps extends object>({
  children,
  ...props
}: NavItemProps<TPopoverProps>) {
  return <NavItemDefault {...props}>{children}</NavItemDefault>;
}
